import type { AdminGuideItem } from '../types';
import { useLanguage } from '../i18n/context';
import { CollapsibleItems, DetailDisclosure, ExpandableText } from './Expandable';
import styles from '../App.module.css';

interface AdminGuideProps {
  items: AdminGuideItem[];
}

function fallbackDetail(title: string, body: string, when: string | undefined, locale: string): string {
  const whenLine =
    locale === 'en'
      ? when
        ? ` Timing: ${when}.`
        : ''
      : locale === 'zh'
        ? when
          ? ` 时机：${when}。`
          : ''
        : when
          ? ` 時期の目安：${when}。`
          : '';
  if (locale === 'en') {
    return `${body}${whenLine} Keep documents (maternity handbook, insurance card, receipts). Confirm the latest rules with Niigata City or your insurer.`;
  }
  if (locale === 'zh') {
    return `${body}${whenLine} 请保管母子手册、保险证、收据。最新规定请向新潟市或保险方确认。`;
  }
  return `${body}${whenLine} 「${title}」は窓口や保険者で最新の要件が変わることがあります。母子手帳・保険証・領収書をまとめ、不明点は市の子育て・国保窓口か産院に確認してください（新潟市在住の方向けの目安）。`;
}

export function AdminGuide({ items }: AdminGuideProps) {
  const { locale } = useLanguage();

  return (
    <CollapsibleItems total={items.length} initial={3}>
      {(visible) => (
        <div className={styles.adminList}>
          {items.slice(0, visible).map((item) => (
            <div key={item.id} className={styles.adminCard}>
              <div className={styles.adminHeader}>
                <h4 className={styles.adminTitle}>{item.title}</h4>
                {item.when && <span className={styles.adminWhen}>{item.when}</span>}
              </div>
              <ExpandableText text={item.body} limit={64} className={styles.adminBody} />
              <DetailDisclosure
                detail={item.detail || fallbackDetail(item.title, item.body, item.when, locale)}
              />
            </div>
          ))}
        </div>
      )}
    </CollapsibleItems>
  );
}
